import { FormProvider, useForm } from 'react-hook-form';
import { useQueryClient } from '@tanstack/react-query';
import { DialogContent, Grid as MuiGrid, DialogActions } from '@mui/material';
import { makeStyles } from '@mui/styles';

// actions
import { deleteDocumentById } from '../../api/DocumentsService';
// platform helpers
import { delayedEvent } from '../../utils/eventUtils';
import { Modal } from '../modals/v2/helpers/v2.modal.helpers';

// components
import CBButton from '../Buttons/CbButton';

// constants
import { queries } from '../../queries';
import useNotifications from '../../_lib/notifications/useNotifications';

export const useDeleteDocument = () => {
  return (docId: any) => Modal.show(DeleteDocumentConfig, { data: { docId } });
};

export const DeleteDocument = ({ data, close }: any) => {
  const notifications = useNotifications();

  const classes = styles();
  const queryClient = useQueryClient();
  const { handleSubmit, ...methods } = useForm({});
  const {
    formState: { isSubmitting },
  } = methods;

  const onSubmit = () => {
    const { docId } = data;
    deleteDocumentById({ docId })
      .then(() => {
        notifications.success('Deleted the document successfully');

        delayedEvent('table-refetch', 500, 'UWDocuments');
        queryClient.invalidateQueries(queries.accounts.list._def);

        close();
      })
      .catch(() => {
        notifications.error('Unable to delete the document');
      });
  };

  const handleCancel = () => {
    close();
  };

  return (
    // @ts-expect-error TS(2741): Property 'handleSubmit' is missing in type '{ chil... Remove this comment to see the full error message
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <DialogContent classes={{ root: classes.container }}>
          <MuiGrid>
            <p className={classes.description}>
              Are you sure you want to delete the document?
            </p>
          </MuiGrid>
        </DialogContent>
        <DialogActions>
          <CBButton action={handleCancel} styleName="cancel">
            Cancel
          </CBButton>
          <CBButton
            type="submit"
            loading={isSubmitting}
            disabled={isSubmitting}
            styleName="ctaButton"
            buttonText="Delete"
            // @ts-expect-error TS(2339): Property 'declineButton' does not exist on type 'C... Remove this comment to see the full error message
            customClass={classes.declineButton}
          />
        </DialogActions>
      </form>
    </FormProvider>
  );
};

const styles = makeStyles(({ palette }) => ({
  description: {
    fontSize: '1.167rem',
    color: palette.primary.main,
    lineHeight: 1.5,
    fontStyle: 'italic',
    textAlign: 'center',
    margin: '0 0 2rem 0 !important',
  },
  container: {
    flex: '1 1 auto',
    padding: '0 5rem 0.5rem 5rem',
    'overflow-y': 'visible',
  },
}));

export const DeleteDocumentConfig = {
  DeleteDocument: {
    component: DeleteDocument,
    config: { title: 'Delete document', maxWidth: 'md' },
  },
};
